import {
    Component,
    OnInit,
    ViewEncapsulation,
    ViewContainerRef
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Helpers } from '../../../../../../helpers';
import { SweetAlertService } from '../../../../../../_services/sweetalert.service';
import { ValidationService } from '../../../../../../_services/validation.service';
import { BaseComponent } from '../../../base.component';
import { Customer } from '../../../../../../models/customer';
import { CustomerService } from '../../../../../../services/customer.service';

@Component({
    selector: 'app-update-customer',
    templateUrl: './update-customer.component.html',
    encapsulation: ViewEncapsulation.None
})
export class UpdateCustomerComponent extends BaseComponent implements OnInit {
    model: Customer = new Customer();

    constructor(
        private customerService: CustomerService,
        private router: Router,
        route: ActivatedRoute
    ) {
        super();
        this.model.id = route.snapshot.params['id'];
    }

    ngOnInit() {
        this.initPhoneMasks();
        this.initTaxMasks();
        this.getCustomer();
    }

    initPhoneMasks() {
        (<any>$('#phone')).inputmask({
            mask: '(999) 999 9999'
        });
    }

    initTaxMasks() {
        (<any>$('#taxNumber')).inputmask({
            mask: '99999999999'
        });
    }

    getCustomer() {
        Helpers.setLoading(true);
        this.customerService.find(this.model.id).subscribe(res => {
            this.model = res.data;
            Helpers.setLoading(false);
        });
    }

    validate(event) {
        var customRules = this.validationService.customRules;
        return this.validationService.validate(event, {
            rules: {
                name: customRules.requiredText
            }
        });
    }

    updateCustomer() {
        var _self = this;
        Helpers.setLoading(true);
        this.model.phone = (<any>$('#phone')).val();
        this.model.taxNumber = (<any>$('#taxNumber')).val();
        this.customerService.update(this.model).subscribe(res => {
            Helpers.setLoading(false);
            this.swalService.successUpdate();
            setTimeout(function() {
                _self.router.navigate(['/publisher/customer/list']);
            }, 1000);
        });
    }
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/theme/pages/default/publisher/customer/update-customer/update-customer.component.ts